import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { EhrExportAlertLike, getEhrSyncFailureUserMessage } from "@utils/ehrActions";

import { Label } from "@fronterahealth/frontera-ui-components";

import { ApiReportEhrSyncChoices } from "@api/graphql/types-and-hooks";

interface EhrSyncFailureStripProps {
  ehrSync: ApiReportEhrSyncChoices | null | undefined;
  ehrSyncAlerts: EhrExportAlertLike;
}

/** Compact full-width strip for use inside the sticky subheader when an EHR export sync has failed. */
export const EhrSyncFailureStrip: React.FC<EhrSyncFailureStripProps> = ({ ehrSync, ehrSyncAlerts }) => {
  if (ehrSync !== ApiReportEhrSyncChoices.Failure) return null;

  const message = getEhrSyncFailureUserMessage(ehrSyncAlerts);

  return (
    <div
      className="flex w-full flex-row items-center gap-2 border-b border-non-semantic-stroke-red bg-non-semantic-fill-red-subtle px-6 py-2"
      data-testid="ehr-sync-failure-strip"
    >
      <ExclamationTriangleIcon className="h-4 w-4 shrink-0 text-semantic-text-onsubtle-negative" aria-hidden />
      <Label size="small" className="text-semantic-text-onsubtle-negative">
        {message}
      </Label>
    </div>
  );
};
